import { useGetSafeClientCode, useIsRootPage } from '@/hooks/router'
import { Link, useMatchRoute } from '@tanstack/react-router'
import { CandlestickChartIcon, HomeIcon, LucideProps } from 'lucide-react'

import {
    NavigationMenu,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    navigationMenuTriggerStyle,
} from '@/components/navigationMenu'

import { cn } from '@/utils/cn'

import Logo from '../logo'

// import { useIdentity } from '@/state/identity'
// import { Avatar, AvatarFallback, AvatarImage } from '@/components/avatar'
import { UserSettingsNavigationItem } from './-components/userSettings'

const NavigationLink = (props: {
    icon: React.ForwardRefExoticComponent<LucideProps & React.RefAttributes<SVGSVGElement>>
    text: string
    to: string
}) => {
    const client_code = useGetSafeClientCode()
    const match = useMatchRoute()
    const isActive = match({ to: props.to, fuzzy: props.to !== '/$client_code' })

    const Icon = props.icon
    return (
        <NavigationMenuItem className="ml-0">
            <NavigationMenuLink
                asChild
                active={isActive}
                className={cn(navigationMenuTriggerStyle(), 'w-56 justify-start rounded-none bg-transparent pl-6')}
            >
                <Link to={props.to as any} params={{ client_code }}>
                    <Icon className="mr-3 h-5 w-5" />
                    {props.text}
                </Link>
            </NavigationMenuLink>
        </NavigationMenuItem>
    )
}

const Navigation = () => {
    const isRoot = useIsRootPage()

    if (isRoot) {
        // We don't render the nav on root because that's the client selector
        return null
    }

    return (
        <div className="flex w-56 flex-shrink-0 flex-col justify-between border-r border-border bg-accent px-0 py-2 dark:bg-secondary">
            <Logo className="mb-6 ml-4 mt-4" />

            <NavigationMenu className="max-w-56 items-start">
                <NavigationMenuList className="m-0 flex-col space-x-0">
                    <NavigationLink icon={HomeIcon} text="Dashboard" to="/$client_code" />
                    <NavigationLink icon={CandlestickChartIcon} text="Markets" to="/$client_code/markets" />
                </NavigationMenuList>
            </NavigationMenu>
            <UserSettingsNavigationItem />
        </div>
    )
}

export default Navigation
